export class SSRContentStateManager {
	private contentStateData: any = null;
	private hasContentStateData = false;
	private contentStateDataConsumers = new Set<(data: any) => void>();

	setContentStateData(data: any): void {
		if (data === null) {
			this.contentStateData = null;
			this.hasContentStateData = false;
			this.contentStateDataConsumers.clear();
			return;
		}

		this.contentStateData = data;
		this.hasContentStateData = true;

		const consumers = this.contentStateDataConsumers;
		this.contentStateDataConsumers = new Set();
		consumers.forEach((consumer) => consumer(data));
	}

	getContentStateData(): any {
		return this.contentStateData;
	}

	onContentStateDataAvailable(consumer: (data: any) => void): void {
		if (this.hasContentStateData) {
			consumer(this.contentStateData);
			return;
		}

		this.contentStateDataConsumers.add(consumer);
	}
}
